var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDownFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 0 24)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM8.292 11.723L11.221 14.678C11.434 14.893 11.712 15 11.991 15C12.2826 14.9994 12.5623 14.8837 12.769 14.678L15.709 11.713C15.8956 11.524 16.0002 11.2691 16.0002 11.0035C16.0002 10.7379 15.8956 10.483 15.709 10.294C15.617 10.2009 15.5075 10.127 15.3867 10.0766C15.2659 10.0261 15.1364 10.0001 15.0055 10.0001C14.8746 10.0001 14.7451 10.0261 14.6243 10.0766C14.5035 10.127 14.394 10.2009 14.302 10.294L11.995 12.621L9.697 10.304C9.60525 10.2108 9.4959 10.1369 9.37529 10.0864C9.25469 10.0359 9.12525 10.0099 8.9945 10.0099C8.86375 10.0099 8.73431 10.0359 8.61371 10.0864C8.4931 10.1369 8.38375 10.2108 8.292 10.304C8.10519 10.4929 8.00042 10.7478 8.00042 11.0135C8.00042 11.2792 8.10519 11.5341 8.292 11.723Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownFilled);
export default __webpack_public_path__ + "static/media/chevron-down-filled.70ddabf4.svg";
export { ForwardRef as ReactComponent };